exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#splashPanel.splash-mobile,#splashPanel.splash-wechat{overflow:hidden;min-height:600px;background-color:#333;background:-webkit-linear-gradient(#000,#555);background:-o-linear-gradient(#000,#555);background:-moz-linear-gradient(#000,#555);background:linear-gradient(#000,#555)}#splashPanel.splash-wechat{background:#333}.splash-mobile>img{margin-left:20px;margin-top:40px;width:100%}.splash-wechat>img{width:100vw}.splash-mobile .splash-logo-container{margin:70px 0 45px}.splash-mobile .splash-logo-container article h3{font-size:18px}span.link{color:#ebc829;text-decoration:underline;clear:both;float:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/styles/mobile.css
// module id = 225
// module chunks = 0